// Exact-suffix match (not substring): `perplexity.ai.evil.com` must not match.
export const isRecognizedPerplexityHost = (hostname) => hostname === 'perplexity.ai' ||
    hostname.endsWith('.perplexity.ai') ||
    hostname === 'perplexity.com' ||
    hostname.endsWith('.perplexity.com');
/**
 * Resolve a redirect URL to a safe target. Same-origin URLs are returned
 * verbatim; a recognized cross-Perplexity-host URL keeps its path on
 * `currentOrigin` (so a www callbackUrl survives on enterprise and vice versa);
 * anything else returns '/'. Cross-host input only ever yields a single-slash-
 * rooted path, never an absolute or protocol-relative reference, so it can't
 * become an open redirect. `currentOrigin` is passed in so this works on both
 * server (request origin) and client.
 */
export const resolveSameSiteRedirect = (url, currentOrigin) => {
    if (!url) {
        return '/';
    }
    let parsed;
    try {
        parsed = new URL(url, currentOrigin);
    }
    catch {
        return '/';
    }
    if (parsed.origin === currentOrigin) {
        return url;
    }
    if (isRecognizedPerplexityHost(parsed.hostname)) {
        const path = parsed.pathname + parsed.search + parsed.hash;
        // A recognized host can still carry a path that begins with a second slash
        // (literal `//`, or a backslash the URL parser rewrites to `/`). Returning
        // it would yield a protocol-relative reference (`//evil.com`) that navigates
        // to a foreign origin. Reject anything not single-slash-rooted — mirrors the
        // Go safeSameSitePath guard so the two stay in lockstep.
        if (!path.startsWith('/') || path.startsWith('//')) {
            return '/';
        }
        return path;
    }
    return '/';
};
//# sourceMappingURL=resolveSameSiteRedirect.js.map